import PropTypes from 'prop-types';
import { find, includes, path, pathOr, propEq } from 'ramda';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import React, { Component } from 'react';

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import grey from '@material-ui/core/es/colors/grey';

import { readEndpointDedup } from '../../modules/reducers/api';

const styles = {
  message: {
    name: {
      color: 'rgba(0, 0, 0, 0.87)', // darkBlack from material-ui
    },
  },
  datetime: {
    fontSize: 12,
    color: grey[700],
  },
};


class NoCapacityMessage extends Component {
  static propTypes = {
    // own props
    message: PropTypes.shape({
      type: PropTypes.oneOf(['dashboard-message']).isRequired,
      id: PropTypes.string.isRequired,
      attributes: PropTypes.shape({
        'sender-type-name': PropTypes.oneOf(['route-blockage']).isRequired,
        'sender-id': PropTypes.number.isRequired,
        'payload': PropTypes.shape({
          'company': PropTypes.number.isRequired,
        }),
      }).isRequired,
    }).isRequired,
    routeBlockageNames: PropTypes.shape({}).isRequired,

    // state props
    company: PropTypes.shape({}),

    // dispatch props
    readEndpointDedup: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { message, company, readEndpointDedup } = this.props;

    if ((message.attributes.action === 'CREATE' || message.attributes.action === 'UPDATE') && !company) {
      readEndpointDedup(`company/${path(['attributes', 'sender-id'], message)}`);
    }
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { message, readEndpointDedup } = this.props;
    const { company: nextCompany, message: nextMessage } = nextProps;

    if ((includes(message.attributes.action, ['CREATE', 'UPDATE'])
      || includes(nextMessage.attributes.action, ['CREATE', 'UPDATE']))
      && !nextCompany
    ) {
      readEndpointDedup(`company/${path(['attributes', 'payload', 'company'], message)}`);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    // Never update when not a CREATE or UPDATE noCapacity message.
    if (this.props.message.attributes.action !== 'CREATE' &&
      this.props.message.attributes.action !== 'UPDATE'
    ) {
      return false;
    }

    // Only update if a previously unavailable company has loaded.
    return !(this.props.company && nextProps.company);
  };

  render() {
    const { message, routeBlockageNames, company } = this.props;

    if (message.attributes.action !== 'CREATE' && message.attributes.action !== 'UPDATE') {
      return null;
    }

    if (!company) {
      return (
        <ListItem alignItems="flex-start">
          <ListItemText inset primary="Laden..." />
        </ListItem>
      )
    }

    const routeBlockageId = path(['attributes', 'sender-id'], message);
    const routeBlockageName = routeBlockageNames[routeBlockageId] || 'Onbekend';
    const companyName = path(['attributes', 'name'], company) || 'Onbekend';
    const datetime = new Date(path(['attributes', 'created-at'], message));

    return (
      <ListItem alignItems="flex-start">
        <ListItemText
          primary={
            <span>
              Geen capaciteit<br />
              <span style={styles.datetime}>{datetime.toLocaleString()}</span>
            </span>
          }
          secondary={
            <span style={{ margin: 0 }}>
              <span style={styles.message.name}>{companyName}</span> --
              Op stremming `{routeBlockageName}`.
            </span>
          }
        />
      </ListItem>
    );
  };
}


const selectCompanyId = (state, ownProps) => path(['message', 'attributes', 'payload', 'company'], ownProps);
const selectCompanies = state => pathOr([], ['api', 'company', 'data'], state);

const makeGetCompany = () => createSelector(
  [selectCompanyId, selectCompanies],
  (cId, cs) => find(propEq('id', String(cId)))(cs),
);

const makeMapStateToProps = () => {
  const getCompany = makeGetCompany();

  return (state, ownProps) => ({
    company: getCompany(state, ownProps),
  });
};

const mapDispatchToProps = {
  readEndpointDedup,
};

export default connect(makeMapStateToProps, mapDispatchToProps)(NoCapacityMessage);
